import { create } from 'zustand'

import { strToBool } from '../../utils/util';

const convertFilters = (filters) => {
  let queryString = "";
  // iterate through query object
  for (let key in filters) {
    // if query value is not an object (primitive), append to queryString
    if (typeof filters[key] !== "object") {
      queryString += `&${key}=${encodeURIComponent(filters[key])}`;
    } else if (filters[key] instanceof Date) {
      queryString += `&${key}=${filters[key].toISOString()}`; // Convert date to ISO string
    }else if (Array.isArray(filters[key])) { // if query value is an array, join values and append to queryString
      queryString += `&${key}=${filters[key].map(cur => encodeURIComponent(cur)).join(",")}`;
    } else { // if query value is an object, iterate through object and append to queryString
      for (let subKey in filters[key]) {
        let value = Array.isArray(filters[key][subKey]) ? filters[key][subKey].map(cur => encodeURIComponent(cur)).join(",") : filters[key][subKey]; // if value is an array, join values
        queryString += `&${key}[${subKey}]=${value}`;
      }
    }
  }
  return queryString;
}


const convertStaticFilters = (filters) => {
  console.log(filters, "static filters")
  let queryString = "";
  // iterate through query object
  for (let key in filters) {
   queryString += `&[ignore][${key}]=${encodeURIComponent(filters[key])}`
  }
  return queryString;
}


const getValue = (e, type) => {
  let value;
  if (type === "check") {
    value = e.target.checked;
  } else if (type === "boolean") {
    value = strToBool(e.target.value);
  } else if (type === "date" || type === "range" || type === "array") {
    value = e;
  } else {
    value = e.target.value;
  }
  return value;
}

const handleStaticFilter = (reportType, fieldName, value, set) => {
  set((prevQuery) => {
    const newQuery = { ...prevQuery.staticFilters[reportType] };
    newQuery[fieldName] = value;
    return { staticFilters: { ...prevQuery.staticFilters, [reportType]: newQuery } };
  });
}


const handleFilter = (e, reportType, fieldName, queryType, fieldType, set) => {
  set((prevQuery) => {
    const newQuery = { ...prevQuery.filters };

    // Create a new object for reportType if it doesn’t exist, or copy the existing one
    newQuery[reportType] = newQuery[reportType]
      ? { ...newQuery[reportType] }
      : {};

    if (!queryType) {
      // If no queryType is provided, set the entire field to the value directly
      newQuery[reportType][fieldName] = e;
    } else {
      const value = getValue(e, fieldType);
       // Create a new object for fieldName if it doesn’t exist, or copy the existing one
      newQuery[reportType][fieldName] = newQuery[reportType][fieldName]
      ? { ...newQuery[reportType][fieldName] }
      : {};
      newQuery[reportType][fieldName][queryType] = value;
    }

    return { filters: newQuery };
  });
};

const resetFilters = (reportType, fieldName, queryType, refresh = false, set) => {
  
  set((prevQuery) => {
    const newQuery = { ...prevQuery.filters };
    let filterString = { ...prevQuery.filterString };
    // If reportType is not provided, reset all table filters
    if (!reportType) {
      return { filters: {}, filterString: {} };
    }
    if (!newQuery[reportType]) {
      return;
    }
    // If fieldName is not provided, reset all filters for the table
    if (!fieldName) {
      delete newQuery[reportType];
      delete filterString[reportType];
      return { filters: newQuery, filterString };
    }
    if (!newQuery[reportType][fieldName]) {
      return;
    }
    // If queryType is provided, remove the specific query type, else remove the entire field
    if (queryType) {
      newQuery[reportType] = {
        ...newQuery[reportType],
        [fieldName]: { ...newQuery[reportType][fieldName] },
      };
      delete newQuery[reportType][fieldName][queryType];
    } else {
      newQuery[reportType] = { ...newQuery[reportType] };
      delete newQuery[reportType][fieldName];
    }
    // If refresh is true, convert filters to filterString
    if (refresh) {
      filterString = { ...filterString, [reportType]: convertFilters(newQuery[reportType]) };
    }
    return { filters: newQuery, filterString };
  });
}

const useReportStore = create((set) => ({
  reportType: "sales",
  setReportType: (reportType) => set({ reportType }),
  filters: {},
  filterString: "",
  staticFilters: {},
  staticFilterString: "",
  handleStaticFilters: (reportType, fieldName, value) => handleStaticFilter(reportType, fieldName, value, set),
  handleFilter: (e, reportType, fieldName, queryType = null, fieldType = null) => handleFilter(e, reportType, fieldName, queryType, fieldType, set),
  resetFilters: (reportType, fieldName = null, queryType = null, refresh = false) => resetFilters(reportType, fieldName, queryType, refresh, set),
  reportResults: {},
  setReportResults: (results, reportType) => set(state => ({ reportResults: { ...state.reportResults, [reportType]: results } })),
  reportLoading: {},
  setReportLoading: (loading, reportType) => set(state => ({ reportLoading: { ...state.reportLoading, [reportType]: loading } })),
  convertFilters: (reportType) => set((state) => ({
    filterString: { ...state.filterString, [reportType]: convertFilters(state.filters[reportType]) }
  })),
  convertStaticFilters: (reportType) => set((state) => ({
    staticFilterString: { ...state.staticFilterString, [reportType]: convertStaticFilters(state.staticFilters[reportType]) }
  }))
}))

export default useReportStore;